import useRegistration from './useRegistration';
import useRegistrationByType from './useRegistrationByType';

export { useRegistration, useRegistrationByType };
